// extracted by mini-css-extract-plugin
export default {"textLogo":"nav_textLogo__bU6vt"};